import axios from '@/utils/request'
var Qs = require('qs')

export default {
  in_type: ['init', 'check', 'arrive', 'allocate', 'rework', 'returnBack', 'prepared', 'processed', 'rent', 'other'],
  out_type: ['sales', 'check', 'allocate', 'damage', 'rework', 'rent', 'other', 'salesPrepared', 'salesPurchase', 'salesProcess', 'returnBack'],
  count_day: ['today', 'yesterday', 'week', 'lastweek', 'month', 'lastmonth'],

  // 2020-09-12
  search(params) {
    return axios.get('/stock-in-outs', params)
  },
  // // 2020-09-06
  // create(params) {
  //   return axios.post('/stock-in-outs', params)
  // },
  // 2020-09-06
  findByInventoryId(inventoryId) {
    return axios.get('/stock-in-outs/find-by-inventory-id/' + inventoryId)
  },
  // 2020-11-16
  batchIn(params) {
    return axios.post('/stock-in-outs/batch-in', params)
  },
  // 2020-11-16
  batchOut(params) {
    return axios.post('/stock-in-outs/batch-out', params)
  },
  // 2020-09-11
  count(params) {
    return axios.get('/stock-in-outs/count', params)
  },
  // 2020-09-12
  exportExcel(params) {
    return axios.get('/stock-in-outs/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },

}

